import React from "react";
import { Button } from "reactstrap";

const OptionalButton = ({ show, ...rest }) => {
	return <>{show && <Button {...rest} />}</>;
};

export default OptionalButton;
